export const FETCH_DELETE_DOCUMENTS_PERMANENTLY_REQUEST = 'FETCH_DELETE_DOCUMENTS_PERMANENTLY_REQUEST'
export const FETCH_DELETE_DOCUMENTS_PERMANENTLY_SUCCESS = 'FETCH_DELETE_DOCUMENTS_PERMANENTLY_SUCCESS'
export const FETCH_DELETE_DOCUMENTS_PERMANENTLY_FALUIRE = 'FETCH_DELETE_DOCUMENTS_PERMANENTLY_FALUIRE'
